import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";

const MyTeamAttendanceTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">Employee</div>,
      dataIndex: "employee",
      key: "employee",
    },
    {
      title: <div className="text-table">Late</div>,
      dataIndex: "late",
      key: "late",
    },
    {
      title: <div className="text-table">Absence</div>,
      dataIndex: "absence",
      key: "absence",
    },
    {
      title: <div className="text-table">Early</div>,
      dataIndex: "early",
      key: "early",
    },
    {
      title: <div className="text-table">Not Stamp In</div>,
      dataIndex: "notStampIn",
      key: "notStampIn",
    },
    {
      title: <div className="text-table">Not Stamp Out</div>,
      dataIndex: "notStampOut",
      key: "notStampOut",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
};

export default MyTeamAttendanceTable;
